import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/workspace-error-log/page';

export const Route = createFileRoute('/_app/settings/workspace-error-log/')({
  component: Page,
});
